import clsx from 'clsx';
import type React from 'react';

/**
 * Render the passed BlockTabsItem inside a container which can
 * be displayed or not depending on selected tab.
 */
export function BlockTabsItemContainer(props: {
    active?: boolean;
    children: React.ReactNode;
}): React.ReactElement {
    const { active, children, ...rest } = props;

    return (
        <div
            className={clsx('break-inside-avoid-page', active ? 'flex flex-col' : 'hidden')}
            {...rest}
        >
            {children}
        </div>
    );
}
